module.exports = __webpack_public_path__ + "img/icons BFr_25.7880e2a5.svg";